import React from 'react';

export default function TextareaComponent(rest) {
  return (
    <textarea
      style={{
        boxSizing: 'border-box',
        width: '473px',
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: 1.5,
        padding: '8px 12px',
        borderRadius: '12px',
        border: '1px solid #ddd',
        outline: 'none', // to remove default outline
      }}
      aria-label="minimum height"
      rows={5}
      placeholder="Tell us why you want to join this course (optional)"
      {...rest}
    />
  );
}
